import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Page } from '../../components/Layout';
import { LoadingState } from '../../components/states';
import { Button } from '../../components/ui';
import { ApiError } from '../../lib/api';
import { clubApi, useClubAction } from './useClubActions';
import { t } from '../../i18n';

/** Landing page for shared invite links: /join/:code */
export function JoinClubPage() {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const join = useClubAction((c: string) => clubApi.joinByCode(c), 'Welcome to the club!');
  const started = useRef(false);

  useEffect(() => {
    if (!code || started.current) return;
    started.current = true;
    join.mutate(code, {
      onSuccess: (club) => navigate(`/clubs/${club.id}`, { replace: true }),
      onError: (e) => setError(e instanceof ApiError ? e.message : t('Could not join')),
    });
  }, [code, join, navigate]);

  return (
    <Page>
      {error ? (
        <div className="py-16 text-center">
          <div className="text-4xl">⬢</div>
          <div className="mt-2 font-display text-2xl font-bold uppercase">{t('Can’t join')}</div>
          <p className="mt-2 text-sm text-ink-400" data-testid="join-error">
            {error}
          </p>
          <Button className="mt-6" variant="secondary" onClick={() => navigate('/clubs', { replace: true })}>
            {t('Browse clubs')}
          </Button>
        </div>
      ) : (
        <LoadingState label={t('Joining club…')} />
      )}
    </Page>
  );
}
